<template>
    <div class="z-10">
        <PageComponent 
            :loader="loader" @showLoader="showLoader" @hideLoader="hideLoader"
            :addButtonLabel="addButtonLabel"
            @handleAddNew="addNewAssignment"
            :searchFilters="searchFilters"
            @searchPage="searchAssignments"
            @resetFilters="resetFilters"
            @removeItem="removeAssignment"
            @removeSelectedItems="removeAssignments"
            @printList="printCasesList"
            @printExcel="downloadCasesExcel"
            @printCSV="downloadCasesCSV"
            :addingRight="addingRight"
            :removingRight="removingRight"
            :rightsModule="rightsModule"
            :columns="tableColumns"
            :rows="assignList"
            :actions="actions"
            :idField="idField"
            @handleSelectionChange="handleSelectionChange"
            @handleActionClick="handleActionClick"
            :groupingKey=true
            :count="propCount"
            :currentPage="currentPage"
            :result="propArrLen"
            @loadPrev="loadPrev"
            @loadNext="loadNext"
            @firstPage="firstPage"
            @lastPage="lastPage"
            :showNextBtn="showNextBtn"
            :showPreviousBtn="showPreviousBtn"
            :selectedValue="selectedValue"
            @selectSearchQuantity="selectSearchQuantity"
        />
        <MovableModal v-model:visible="propModalVisible" :title="title" :modal_top="modal_top" :modal_left="modal_left" :modal_width="modal_width"
            :loader="modal_loader" @showLoader="showModalLoader" @hideLoader="hideModalLoader" @closeModal="closeModal">
            <DynamicForm 
                :fields="formFields" :flex_basis="flex_basis" :flex_basis_percentage="flex_basis_percentage" 
                :displayButtons="displayButtons" @handleSubmit="saveAssignment" @handleReset="handleReset"
            />
        </MovableModal>
    </div>
</template>

<script>
import axios from "axios";
import { ref, computed, onMounted, onBeforeMount, watch} from 'vue';
import PageComponent from '@/components/PageComponent.vue';
import MovableModal from '@/components/MovableModal.vue'
import DynamicForm from '../NewDynamicForm.vue';
import { useStore } from "vuex";
import { useToast } from "vue-toastification";
import PrintJS from 'print-js';

export default{
    name: 'Assigned_Assets',
    components:{
        PageComponent, MovableModal,DynamicForm
    },
    setup(){
        const store = useStore();     
        const toast = useToast();
        const loader = ref('none');
        const modal_loader = ref('none');
        const emplComponentKey = ref(0);
        const levComponentKey = ref(0);
        const idField = 'asset_assignment_id';
        const addButtonLabel = ref('New Assignment');
        const addingRight = ref('Adding Asset Assignments');
        const removingRight = ref('Deleting Asset Assignments');
        const rightsModule = ref('HR');
        const title = ref('Assignment Details');
        const submitButtonLabel = ref('Add');
        const selectedIds = ref([]);
        const assignList = ref([]);
        const propResults = ref([]);
        const propArrLen = ref(0);
        const propCount = ref(0);
        const pageCount = ref(0);
        const selectedValue = ref(50);
        const currentPage = ref(1);
        const showNextBtn = ref(false);
        const showPreviousBtn = ref(false);
        const propModalVisible = ref(false);
        const flex_basis = ref('');
        const flex_basis_percentage = ref('');
        const displayButtons = ref(true);
        const errors = ref([]);
        const modal_top = ref('150px');
        const modal_left = ref('500px');
        const modal_width = ref('30vw');
        const employeeID = ref('');
        const assetID = ref('');
        const isEditing = computed(()=> store.state.Assigned_Assets.isEditing);
        const selectedAssignment = computed(()=> store.state.Assigned_Assets.selectedAssignment);
        const selectedEmployee = computed(()=> store.state.Assigned_Assets.selectedEmployee);
        const selectedAsset = computed(()=> store.state.Assigned_Assets.selectedAsset);
        const employeeArray = computed(() => store.state.Employees.employeeArr);
        const assetArray = computed(() => store.state.Assets.assetArr);
        const showModal = ref(false);
        const tableColumns = ref([
            {type: "checkbox"},
            {label: "Staff No", key: "staff_number"},
            {label: "Employee Name", key: "employee_name"},
            {label: "Asset Name", key:"asset_name"},
            {label: "Date From", key: "from_date"},
            {label: "Date To", key: "to_date"},
        ])
        const actions = ref([
            {name: 'edit', icon: 'fa fa-edit', title: 'Edit Assign', rightName: 'Editing Asset Assignments'},
            {name: 'delete', icon: 'fa fa-trash', title: 'Delete Assign', rightName: 'Deleting Asset Assignments'},
        ])
        const companyID = computed(()=> store.state.userData.company_id);
        const employee_name_search = ref('');
        const staff_number_search = ref('');
        const date_from_search = ref('');
        const date_to_search = ref('');
        const asset_name_search = ref('');
        const searchFilters = ref([
            {type:'text', placeholder:"Asset...", value: asset_name_search, width:32,},
            {type:'text', placeholder:"Staff No...", value: staff_number_search, width:32,},
            {type:'text', placeholder:"Employee Name...", value: employee_name_search, width:48,},
            {type:'date',value: date_from_search, width:32, title: "Date From"},
            {type:'date',value: date_to_search, width:32, title: "Date To"},
        ]);
        const handleSelectionChange = (ids) => {
            selectedIds.value = ids;
        };
        const fetchEmployees = async() =>{
            await store.dispatch('Employees/fetchEmployees', {company:companyID.value})
        };
        const handleSelectedEmployee = async(option) =>{
            await store.dispatch('Employees/handleSelectedEmployee', option)
            employeeID.value = store.state.Employees.employeeID;
        };
        const clearSelectedEmployee = async() =>{
            await store.dispatch('Employees/updateState', {employeeID: ''});
            employeeID.value = store.state.Employees.employeeID;
        };
        const fetchAssets = async() =>{
            await store.dispatch('Assets/fetchAssets', {company:companyID.value})
        };
        const handleSelectedAsset = async(option) =>{
            await store.dispatch('Assets/handleSelectedAsset', option)
            assetID.value = store.state.Assets.assetID;
        };
        const clearSelectedAsset = async() =>{
            await store.dispatch('Assets/updateState', {assetID: ''});
            assetID.value = store.state.Assets.assetID;
        };
        const formFields = ref([]);
        const employeeValue = computed(() => {
           return (selectedAssignment.value && selectedAssignment.value.employee && !employeeID.value) ? selectedAssignment.value.employee.employee_id : employeeID.value;

        });
        const assetValue = computed(() => {
           return (selectedAssignment.value && selectedAssignment.value.asset && !assetID.value) ? selectedAssignment.value.asset.asset_id : assetID.value;

        });
        const updateFormFields = () => {
            formFields.value = [
                {  
                    type:'search-dropdown', label:"Asset", value: assetValue.value, componentKey: levComponentKey,
                    selectOptions: assetArray, optionSelected: handleSelectedAsset, required: true,
                    searchPlaceholder: 'Select Asset...', dropdownWidth: '500px', updateValue: selectedAsset.value,
                    clearSearch: clearSelectedAsset
                },
                {  
                    type:'search-dropdown', label:"Employee", value: employeeValue.value, componentKey: emplComponentKey,
                    selectOptions: employeeArray, optionSelected: handleSelectedEmployee, required: true,
                    searchPlaceholder: 'Select Employee...', dropdownWidth: '500px', updateValue: selectedEmployee.value,
                    clearSearch: clearSelectedEmployee
                },
                { type: 'date', name: 'from_date',label: "From Date", value: selectedAssignment.value?.from_date || '', required: true },
                { type: 'date', name: 'to_date',label: "To Date", value: selectedAssignment.value?.to_date || '', required: false },

            ];
        };
        const handleReset = () =>{
            for(let i=0; i < formFields.value.length; i++){
                formFields.value[i].value = '';
            }
            emplComponentKey.value += 1;
            levComponentKey.value += 1;
            assetID.value = '';
            employeeID.value = '';
        }


        watch([selectedAssignment, selectedEmployee, selectedAsset], () => {
            if (selectedAssignment.value && selectedEmployee.value && selectedAsset.value) {
                emplComponentKey.value += 1;
                levComponentKey.value += 1;
                updateFormFields();
            }
            
        }, { immediate: true });
        
        
        const showModalLoader = () =>{
            modal_loader.value = "block";
        }
        const hideModalLoader = () =>{
            modal_loader.value = "none";
        }
        const createAssetAssignment = async() =>{
            showModalLoader();
            let formData = {
                from_date: formFields.value[2].value,
                to_date: formFields.value[3].value,
                employee: employeeID.value,
                employee_id: employeeID.value,
                asset: assetID.value,
                asset_id: assetID.value,
                company: companyID.value
            }
  
            errors.value = [];
            for(let i=2; i < formFields.value.length; i++){
                if(formFields.value[i].value =='' && formFields.value[i].type != 'search-dropdown' && formFields.value[i].required == true){
                    errors.value.push(formFields.value[i].label);
                }
            }
            if(employeeValue.value == '' || assetValue.value == ''){
                errors.value.push('error')
            }

            if(errors.value.length){
                toast.error('Fill In Required Fields');
                hideModalLoader();
            }else{
                try {
                    const response = await store.dispatch('Assigned_Assets/createAssetAssignment', formData);
                    if (response && response.status === 201) {
                        hideModalLoader();
                        toast.success('Success!');
                        handleReset();
                        emplComponentKey.value += 1;
                        levComponentKey.value += 1;
                    }
                    else {
                        toast.error('An error occurred while creating the Assignment.');
                    }
                } catch (error) {
                    console.error(error.message);
                    toast.error('Failed to create Assignment: ' + error.message);
                } finally {
                    hideModalLoader();
                    searchAssignments();
                }
            }
        }
        const updateAssetAssignment = async() =>{
            showModalLoader();
            errors.value = [];
            let formData = {
                asset_assignment: selectedAssignment.value.asset_assignment_id,
                from_date: formFields.value[2].value,
                to_date: formFields.value[3].value,
                employee: employeeValue.value,
                employee_id: employeeValue.value,
                asset: assetValue.value,
                asset_id: assetValue.value,
                company: companyID.value
            }

            for(let i=0; i < formFields.value.length; i++){
                if(formFields.value[i].value =='' && formFields.value[i].type != 'search-dropdown'  && formFields.value[i].required == true){
                    errors.value.push('Error');
                }
            }
            if(employeeValue.value == '' || assetValue.value == ''){
                errors.value.push('error')
            }
            if(errors.value.length){
                toast.error('Fill In Required Fields');
                hideModalLoader();
            }else{
                try {
                    const response = await store.dispatch('Assigned_Assets/updateAssetAssignment', formData);
                    if (response && response.status === 200) {
                        hideModalLoader();
                        handleReset();
                        emplComponentKey.value += 1;
                        toast.success("Sucess!");              
                    } else {
                        toast.error('An error occurred while updating the Assignment.');
                    }
                } catch (error) {
                    console.error(error.message);
                    toast.error('Failed to update Assignment: ' + error.message);
                } finally {
                    hideModalLoader();
                    propModalVisible.value = false;
                    store.dispatch("Assigned_Assets/updateState",{selectedAssignment:null, selectedAsset: null, selectedEmployee: null})
                    searchAssignments();
                }             
            }
        }
        const saveAssignment = () =>{
            if(isEditing.value == true){
                updateAssetAssignment();
            }else{
                createAssetAssignment();
            }
        }
        const removeAssignment = async() =>{
            if(selectedIds.value.length == 1){
                let formData = {
                    company: companyID.value,
                    asset_assignment: selectedIds.value
                }
                try{
                    const response = await store.dispatch('Assigned_Assets/deleteAssetAssignment',formData)
                    if(response && response.status == 200){
                        toast.success("Success");
                        searchAssignments();
                    }
                }
                catch(error){
                    console.error(error.message);
                    toast.error('Failed to remove Assignment: ' + error.message);
                }
                finally{
                    selectedIds.value = [];
                }
            }else if(selectedIds.value.length > 1){
                toast.error("You have selected more than 1 Assignment") 
            }else{
                toast.error("Please Select An Assignment To Remove")
            }
        }
        const removeAssignments = async() =>{
            if(selectedIds.value.length){
                let formData = {
                    company: companyID.value,
                    asset_assignment: selectedIds.value
                }
                try{
                    const response = await store.dispatch('Assigned_Assets/deleteAssetAssignment',formData)
                    if(response && response.status == 200){
                        toast.success("Success");
                        searchAssignments();
                    }
                }
                catch(error){
                    console.error(error.message);
                    toast.error('Failed to remove Assignment: ' + error.message);
                }
                finally{
                    selectedIds.value = [];

                }
            }else{
                toast.error("Please Select An Assignment To Remove")
            }
        }
        const showLoader = () =>{
            loader.value = "block";
        }
        const hideLoader = () =>{
            loader.value = "none";
        }
        const searchAssignments = () =>{
            showLoader();
            showNextBtn.value = false;
            selectedIds.value = [];
            showPreviousBtn.value = false;
            let formData = {
                employee_name: employee_name_search.value,
                staff_number: staff_number_search.value,
                from_date: date_from_search.value,
                to_date: date_to_search.value,
                asset_name: asset_name_search.value,
                company_id: companyID.value,
                page_size: selectedValue.value
            } 
            axios
            .post(`api/v1/asset-assignments-search/?page=${currentPage.value}`,formData)
            .then((response)=>{
                assignList.value = response.data.results;
                store.commit('Assigned_Assets/LIST_ASSETS', assignList.value)
                propResults.value = response.data;
                propArrLen.value = assignList.value.length;
                propCount.value = propResults.value.count;
                pageCount.value = Math.ceil(propCount.value / selectedValue.value);
                if(response.data.next){
                    showNextBtn.value = true;
                }
                if(response.data.previous){
                    showPreviousBtn.value = true;
                }
            })
            .catch((error)=>{
                console.log(error.message);
            })
            .finally(()=>{
                hideLoader();
            })
        };
        const selectSearchQuantity = (newValue) =>{
            selectedValue.value = newValue;
            searchAssignments(selectedValue.value);
        };
        const resetFilters = () =>{
            currentPage.value = 1;
            selectedValue.value = 50;
            staff_number_search.value = "";
            employee_name_search.value = "";
            date_from_search.value = "";
            date_to_search.value = "";
            asset_name_search.value = "";
            searchAssignments();
        }
        const loadPrev = () =>{
            if (currentPage.value <= 1){
                currentPage.value = 1;
            }else{
                currentPage.value -= 1;
            }
            
            searchAssignments();
            // scrollToTop();
        }
        const loadNext = () =>{
            if(currentPage.value >= pageCount.value){
                currentPage.value = pageCount.value;
            }else if(currentPage.value < pageCount.value){
                currentPage.value += 1;
            }
            
            searchAssignments();
            // scrollToTop(); 
        }
        const firstPage = ()=>{
            currentPage.value = 1;
            searchAssignments();
            // scrollToTop();
        }
        const lastPage = () =>{
            currentPage.value = pageCount.value;
            searchAssignments();
            // scrollToTop();
        }
        const addNewAssignment = () =>{
            store.dispatch("Assigned_Assets/updateState",{selectedAssignment:null, selectedEmployee:null, selectedAsset:null});
            emplComponentKey.value += 1;
            levComponentKey.value += 1;
            handleReset();
            updateFormFields();
            propModalVisible.value = true;
            store.dispatch("Assigned_Assets/updateState",{isEditing:false})
            flex_basis.value = '1/3';
            flex_basis_percentage.value = '33.333';
        }
        const handleActionClick = async(rowIndex, action, row) =>{
            if( action == 'edit'){
                const assignID = row['asset_assignment_id'];
                let formData = {
                    company: companyID.value,
                    asset_assignment: assignID
                }
                await store.dispatch('Assigned_Assets/fetchAssetAssignment',formData)
                propModalVisible.value = true;
                flex_basis.value = '1/3';
                flex_basis_percentage.value = '33.333';

            }else if(action == 'delete'){
                const assignID = [row[idField]];
                let formData = {
                    company: companyID.value,
                    asset_assignment: assignID
                }
                await store.dispatch('Assigned_Assets/deleteAssetAssignment',formData).
                then(()=>{
                    searchAssignments();
                })
            }else if(action == 'view'){
                console.log("VIEWING TAKING PLACE");
            }
        }
        const closeModal = () =>{
            propModalVisible.value = false;
        };
        const printCasesList = () =>{
            showLoader();
            let formData = {
                employee_name: employee_name_search.value,
                staff_number: staff_number_search.value,
                company_id: companyID.value,
            } 

            axios
            .post("api/v1/export-disciplinary-cases-pdf/", formData, { responseType: 'blob' })
                .then((response)=>{
                    if(response.status == 200){
                        const blob1 = new Blob([response.data]);
                        // Convert blob to URL
                        const url = URL.createObjectURL(blob1);
                        PrintJS({printable: url, type: 'pdf'});
                    }
                })
            .catch((error)=>{
                console.log(error.message);
            })
            .finally(()=>{
                hideLoader();
            })
        };
        const downloadCasesExcel = () =>{

        };
        const downloadCasesCSV = () =>{
   
        };
        onBeforeMount(()=>{
            searchAssignments();
            fetchAssets();
            fetchEmployees();
            
        })
        return{
            title, searchAssignments,resetFilters, addButtonLabel, searchFilters, tableColumns, assignList,
            currentPage,propResults, propArrLen, propCount, pageCount, showNextBtn, showPreviousBtn,
            loadPrev, loadNext, firstPage, lastPage, idField, actions, handleActionClick, propModalVisible, closeModal,
            submitButtonLabel, showModal, addNewAssignment, showLoader, loader, hideLoader, modal_loader, modal_top, modal_left, modal_width,displayButtons,
            showModalLoader, hideModalLoader, saveAssignment, formFields, handleSelectionChange, flex_basis,flex_basis_percentage,
            removeAssignment, removeAssignments,addingRight,removingRight,rightsModule,printCasesList,selectSearchQuantity,selectedValue,
            downloadCasesCSV,downloadCasesExcel
        }
    }
};
</script>